export default "__VITE_ASSET__9TgDZeqV__"